module.exports = __webpack_public_path__ + "static/media/pro_display_xdr.489d2c43.svg";